import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { ExportLogService } from "@services/exportLog.service";
import { OutsideProcessContractService } from "@services/outsideProcessContract.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "outsideProcessContracts",
	styleUrls: ["outsideProcessContracts.css"],
	templateUrl: "outsideProcessContracts.html"
})
export class OutsideProcessContractsAdminComponent {
	canExportGrid = false;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Outside Process"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any;
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private exportLogService: ExportLogService, private itemService: OutsideProcessContractService, private protectedGridService: ProtectedGridService) {
		this.title = "Outside Processes";
		this.editRow = this.editRow.bind(this);
		this.viewPart = this.viewPart.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.checkGridExportPermissions();
		this.getDataGrid();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Outside Processes")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	getDataGrid() {
		this.gridLoading = true;
		this.itemService.getDataGrid()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Outside Processes";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewPart(e: any) {
		this.router.navigate([`/admin/parts/${e.row.data.partId}`]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}